import { importProvidersFrom } from '@angular/core';

export const provideCubeJsCore = () => [importProvidersFrom()];
